// Helper
import { isDebugEnabled } from './Helper';

// Pages
import AdministratorsPage from 'pages/Administrators';
import ApplicationsPage from 'pages/Applications';
import ApplicationEditPage from 'pages/ApplicationEdit';
import AttributesEditModalPage from 'pages/AttributesEditModal/AttributesEditModal';
import AttributeSocialPhotosPage from 'pages/AttributeSocialPhotos';
import DebugPage from 'pages/Debug';
import DirectoriesPage from 'pages/Directories';
import DirectoryPage from 'pages/Directory';
import FeaturesPage from 'pages/Features/Features';
import GeneralPage from 'pages/General/General';
import HomePage from 'pages/Home';
import HomepagePage from 'pages/Homepage';
import InvitesPage from 'pages/Invites';
import NoRoutePage from 'pages/NoRoute';
import SiftBotPage from 'pages/SiftBot';
import SourcePage from 'pages/Source';
import SourceCreatePage from 'pages/SourceCreate';
import SourceCSVSetupPage from 'pages/SourceCSVSetup';
import SourcePhotoCSVSetupPage from 'pages/SourcePhotoCSVSetup';
import SourceLDAPSetupPage from 'pages/SourceLDAPSetup';
import SourceWizardPage from 'pages/Directory/Wizard';
import PagesPage from 'pages/Pages';
import PageTypesPage from 'pages/PageTypes';
import PersonPage from 'pages/Person';
import PersonProfilesPage from 'pages/PersonProfilesPage';
import WidgetConfiguration from 'pages/Homepage/components/WidgetConfiguration';
import RolesAndPermissionsPage from 'pages/RolesAndPermissions';
import UserRoleEditPage from 'pages/RolesAndPermissions/UserRoleEditPage';
import RoleConfigurationPage from 'pages/RolesAndPermissions/RoleConfiguration';
import ManageRoleMembersPage from 'pages/RolesAndPermissions/ManageRoleMembersPage';
import ManageRolePermissionPage from 'pages/RolesAndPermissions/ManagePermissionPage';

// Icons
import AdministratorsIcon from '@material-ui/icons/Person';
import DirectoriesIcon from '@material-ui/icons/Dns';
import InvitesIcon from '@material-ui/icons/People';
import FeatureIcon from '@material-ui/icons/Tune';
import SettingsIcon from '@material-ui/icons/Settings';
import SiftBotIcon from '@material-ui/icons/AssignmentTurnedIn';
import HomeIcon from '@material-ui/icons/Home';
import APIIcon from '@material-ui/icons/SettingsInputComponent';
import PagesIcon from '@material-ui/icons/Description';
import PersonIcon from '@material-ui/icons/AccountCircle';
import WidgetsIcon from '@material-ui/icons/Widgets';
import RolesAndPermissionsIcon from 'components/Icons/NavDrawer/RolesAndPermissions';

// Types
import { Route } from './types';

import {
  ADMIN_URL,
  APPLICATIONS_URL,
  APP_CREATE_URL,
  ATTRIBUTES_URL,
  DEBUG_URL,
  DIRECTORIES_URL,
  DYNAMIC_PAGES_URL,
  FEATURES_URL,
  GENERAL_URL,
  HOME_URL,
  HOMEPAGE_URL,
  PERSON_PROFILE_URL,
  ROLES_AND_PERMISSIONS_URL,
  SOURCE_URL,
  SOURCE_CREATE_URL,
  USERS_URL,
  WIDGETS_URL,
} from './consts';

import { CSV_WIZARD_URL } from 'pages/Directory/consts';

// (note - pearl) The following routes are in alphabetical order
export const Administrators: Route = {
  name: 'Administrators',
  title: 'Administrators',
  path: `${HOME_URL}${ADMIN_URL}`,
  component: AdministratorsPage,
  Icon: AdministratorsIcon,
  exact: true,
  navExact: true,
  helpArticleLink: 'https://help.justsift.com/en/articles/3931941-administrators',
};

export const Applications: Route = {
  name: 'Applications',
  title: 'API Access',
  path: `${HOME_URL}${APPLICATIONS_URL}`,
  component: ApplicationsPage,
  Icon: APIIcon,
  exact: true,
  navExact: true,
  helpArticleLink: 'https://help.justsift.com/en/articles/4385460-managing-api-access',
};

export const ApplicationCreate: Route = {
  name: 'AttributesEdit',
  title: 'Application Form',
  path: `${HOME_URL}${APP_CREATE_URL}`,
  component: ApplicationEditPage,
  exact: true,
};

export const ApplicationEdit: Route = {
  name: 'AttributesEdit',
  title: 'Application Form',
  path: `${HOME_URL}${APPLICATIONS_URL}/:id`,
  component: ApplicationEditPage,
  exact: true,
};

export const AttributesEditModal: Route = {
  name: 'AttributesEditModal',
  title: 'Create and Edit Attributes',
  path: [
    `${HOME_URL}${ATTRIBUTES_URL}/:entityTypeKey/create/:baseField?`,
    `${HOME_URL}${ATTRIBUTES_URL}/:entityTypeKey/edit/:objectKey`,
  ],
  component: AttributesEditModalPage,
  exact: false,
};

export const AttributeSocialPhotos: Route = {
  name: 'AttributeSocialPhotos',
  title: 'Social Photos',
  path: `${HOME_URL}${ATTRIBUTES_URL}/social-photos`,
  component: AttributeSocialPhotosPage,
  exact: true,
};

export const Directories: Route = {
  name: 'People Data',
  title: 'People Data',
  path: `${HOME_URL}${DIRECTORIES_URL}`,
  component: DirectoriesPage,
  Icon: DirectoriesIcon,
  exact: true,
  navExact: false,
  helpArticleLink: 'https://help.justsift.com/en/articles/8292317-syncing-people-data',
  helpArticleLinkText: 'Learn more about Directories ❯',
};

export const Directory: Route = {
  name: 'Directory',
  title: 'Directory',
  path: `${HOME_URL}${DIRECTORIES_URL}/:id/:tab?`,
  component: DirectoryPage,
  exact: true,
};

export const Features: Route = {
  name: 'Features',
  title: 'Feature Management',
  path: `${HOME_URL}${FEATURES_URL}/:tab?`,
  navSideBarPath: `${HOME_URL}${FEATURES_URL}`,
  component: FeaturesPage,
  Icon: FeatureIcon,
  exact: true,
  navExact: false,
};

export const General: Route = {
  name: 'General',
  title: 'Settings',
  path: `${HOME_URL}${GENERAL_URL}/:tab?`,
  component: GeneralPage,
  Icon: SettingsIcon,
  exact: true,
  navExact: false,
  helpArticleLink: 'https://help.justsift.com/en/articles/2367925-general-settings',
};

export const Home: Route = {
  name: 'Home',
  title: 'Home',
  path: `${HOME_URL}`,
  component: HomePage,
  Icon: HomeIcon,
  exact: true,
  navExact: true,
};

export const Homepage: Route = {
  name: 'Homepage',
  title: 'Homepage',
  path: `${HOME_URL}${HOMEPAGE_URL}/:tab?`,
  component: HomepagePage,
  Icon: WidgetsIcon,
  exact: true,
  navExact: true,
};

export const HomepageWidgetConfiguration: Route = {
  name: 'HomepageWidgetConfiguration',
  title: 'Homepage Widget Configuration',
  path: [
    `${HOME_URL}${WIDGETS_URL}/:widgetId`,
    `${HOME_URL}${WIDGETS_URL}/create/types`,
    `${HOME_URL}${WIDGETS_URL}/create/types/:typeName`,
  ],
  component: WidgetConfiguration,
  exact: true,
};

export const NoRoute: Route = {
  name: 'Not Found',
  title: 'Not Found',
  path: '/404',
  component: NoRoutePage,
};

export const Pages: Route = {
  name: 'Pages',
  title: 'Pages',
  path: `${HOME_URL}${DYNAMIC_PAGES_URL}`,
  component: PagesPage,
  Icon: PagesIcon,
  exact: true,
  navExact: false,
  helpArticleLink: 'https://help.justsift.com/en/articles/5858343-draft-managing-page-types',
};

export const PageTypes: Route = {
  name: 'PageTypes',
  title: 'PageTypes',
  path: `${HOME_URL}${DYNAMIC_PAGES_URL}/:entityTypeKey/:tab?`,
  component: PageTypesPage,
  exact: true,
  navExact: false,
  helpArticleLink: 'http://help.justsift.com/en/articles/5858344-draft-setting-up-a-page-type',
};

export const Person: Route = {
  name: 'Person',
  title: 'Person',
  path: `${HOME_URL}${USERS_URL}/person/:id`,
  component: PersonPage,
  exact: true,
};

export const PersonProfiles: Route = {
  name: 'PersonProfiles',
  title: 'Person Profiles',
  path: `${HOME_URL}${PERSON_PROFILE_URL}/:tab?`,
  component: PersonProfilesPage,
  Icon: PersonIcon,
  exact: true,
};

export const SiftBot: Route = {
  name: 'SiftBot',
  title: 'Profile Completion',
  path: `${HOME_URL}${PERSON_PROFILE_URL}/sift-bot`,
  component: SiftBotPage,
  Icon: SiftBotIcon,
  exact: true,
  navExact: true,
  helpArticleLink: 'https://help.justsift.com/en/articles/3852233-profile-completion',
};

export const Source: Route = {
  name: 'Source',
  title: 'Source',
  path: `${HOME_URL}${DIRECTORIES_URL}/:directoryId${SOURCE_URL}/:sourceId`,
  component: SourcePage,
};

export const SourceCreate: Route = {
  name: 'SourceCreate',
  title: 'New Source',
  path: `${HOME_URL}${DIRECTORIES_URL}/:id/new-source`,
  component: SourceCreatePage,
  exact: true,
};

export const SourceCSVSetup: Route = {
  name: 'SourceCSVSetup',
  title: 'Source CSV Setup',
  path: `${HOME_URL}${DIRECTORIES_URL}/:directoryId${SOURCE_URL}/:sourceId${CSV_WIZARD_URL}`,
  component: SourceCSVSetupPage,
};

export const SourcePhotoCSVSetup: Route = {
  name: 'SourceCSVSetup',
  title: 'Source CSV Setup',
  path: `${HOME_URL}${DIRECTORIES_URL}/:directoryId${SOURCE_URL}/:sourceId/photo-csv-wizard`,
  component: SourcePhotoCSVSetupPage,
};

export const SourceWizard: Route = {
  name: 'SourceWizard',
  title: 'Source Wizard',
  path: [
    `${HOME_URL}${DIRECTORIES_URL}${SOURCE_CREATE_URL}`,
    `${HOME_URL}${DIRECTORIES_URL}/:id${SOURCE_CREATE_URL}`,
    `${HOME_URL}${DIRECTORIES_URL}/:id${SOURCE_URL}/:id${SOURCE_CREATE_URL}`,
  ],
  component: SourceWizardPage,
  helpArticleLink: 'https://help.justsift.com/en/articles/8292317-syncing-people-data',
  helpArticleLinkText: 'Learn more about Directories ❯',
};

export const SourceLDAPSetup: Route = {
  name: 'SourceLDAPSetup',
  title: 'Source LDAP Setup',
  path: `${HOME_URL}${DIRECTORIES_URL}/:directoryId${SOURCE_URL}/:sourceId/ldap-wizard`,
  component: SourceLDAPSetupPage,
};

export const Users: Route = {
  name: 'All Users',
  title: 'All Users',
  path: `${HOME_URL}${USERS_URL}/:tab?`,
  navSideBarPath: `${HOME_URL}${USERS_URL}`,
  component: InvitesPage,
  Icon: InvitesIcon,
  exact: true,
  navExact: false,
  helpArticleLink: 'https://help.justsift.com/en/articles/1835499-user-invites',
};

// (note - pearl) The following routes are not exported into `routes`
export const Debug: Route = {
  name: 'Debug',
  title: 'Debug',
  path: `${HOME_URL}${DEBUG_URL}`,
  component: DebugPage,
  exact: true,
};

export const Documentation: Route = {
  name: 'Documentation',
  title: 'Documentation',
  path: 'https://intercom.help/sift',
  target: '_blank',
  isExternal: true,
};

export const RoleUser: Route = {
  name: 'RoleUser',
  title: 'Role User',
  path: `${HOME_URL}${ROLES_AND_PERMISSIONS_URL}/users/:id`,
  component: UserRoleEditPage,
  exact: true,
};

export const ManageRoleMembers: Route = {
  name: 'ManageRoleMembers',
  title: 'Manage Role Members',
  path: `${HOME_URL}${ROLES_AND_PERMISSIONS_URL}/roles/:roleId/manage-members`,
  component: ManageRoleMembersPage,
  exact: true,
};

export const ManageRolePermission: Route = {
  name: 'ManageRolePermission',
  title: 'Manage Role Permission',
  path: `${HOME_URL}${ROLES_AND_PERMISSIONS_URL}/roles/:roleId/permissions/:permissionId`,
  component: ManageRolePermissionPage,
  exact: true,
};

export const RoleConfiguration: Route = {
  name: 'Role Configuration',
  title: 'Role Configuration',
  path: [
    `${HOME_URL}${ROLES_AND_PERMISSIONS_URL}/create-role`,
    `${HOME_URL}${ROLES_AND_PERMISSIONS_URL}/roles/:id`,
  ],
  component: RoleConfigurationPage,
  exact: true,
};

export const RolesAndPermissions: Route = {
  name: 'Roles/Permissions',
  title: 'Roles/Permissions',
  path: `${HOME_URL}${ROLES_AND_PERMISSIONS_URL}/:tab?`,
  component: RolesAndPermissionsPage,
  Icon: RolesAndPermissionsIcon,
  exact: true,
  navExact: false,
};

// (note - pearl) Route order matters. For example, Directory route has to be exported after
// SourceWizard to avoid SOURCE_CREATE_URL being identified as a directory id.
const routes: Route[] = [
  Home,
  Homepage,
  HomepageWidgetConfiguration,
  Person,
  PersonProfiles,
  Administrators,
  Applications,
  ApplicationCreate,
  ApplicationEdit,
  Directories,
  SourceWizard,
  SourceCreate,
  SourceLDAPSetup,
  SourceCSVSetup,
  SourcePhotoCSVSetup,
  Directory,
  Source,
  AttributesEditModal,
  AttributeSocialPhotos,
  General,
  Users,
  SiftBot,
  Features,
  NoRoute,
  Pages,
  PageTypes,
  RoleUser,
  ManageRoleMembers,
  ManageRolePermission,
  RoleConfiguration,
  RolesAndPermissions,
];

if (isDebugEnabled()) {
  routes.push(Debug);
}

export default routes;
